<template>
  <b-navbar :class="navbarClass" data-cy="musashi-navbar">
    <b-navbar-brand to="/app">
      <UELogo />
    </b-navbar-brand>
    <ul class="navbar-nav">
      <li v-for="item in items" :key="item.name" :class="['nav-item', navItemClass]">
        <router-link :to="item.to" class="nav-link">
          <component :is="item.icon" />{{ item.name }}
        </router-link>
      </li>
    </ul>
    <div class="the_right">
      <div class="d-flex align-items-center">
        <div class="mr-3" v-if="true_user">
          <div>
            Viewing as: <strong>{{ user.first_name }} {{ user.last_name }}</strong>
          </div>
          <div>
            <a class="mr-2" href="/admin/users/stop_impersonating">Log Out</a
            ><a href="/admin">Admin Home</a>
          </div>
        </div>
        <b-nav-item-dropdown no-caret="no-caret">
          <template v-slot:button-content>
            <div class="avatar">
              <img :src="user.gravatar_url" :alt="user.first_name" v-if="user.gravatar_url" />
              <div v-else>{{ user.first_name[0] }}{{ user.last_name[0] }}</div>
            </div>
          </template>
          <b-dropdown-item to="/app/profile">Profile</b-dropdown-item>
          <b-dropdown-item to="/app/account" v-if="!is_viewer">Account</b-dropdown-item>
          <b-dropdown-item href="https://intercom.help/userevidence/en/" target="_blank"
            >Help Center</b-dropdown-item
          >
          <b-dropdown-item href="/users/sign_out">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
    </div>
  </b-navbar>
</template>
<script lang="ts">
import AdvocatesIcon from '@app/graphics/AdvocatesIcon.vue'
import UELogo from '@app/graphics/UELogo.vue'
import SurveysIcon from '@app/graphics/SurveysIcon.vue'
import ResultsIcon from '@app/graphics/ResultsIcon.vue'
import AssetsIcon from '@app/graphics/AssetsIcon.vue'
import { useUserStore } from '@app/stores/UserStore'
import { useFeatureStore } from '@app/stores/FeatureStore'

import { mapState } from 'pinia'
import { isViewer } from '@/helpers/user_helper'

export default {
  components: { UELogo, SurveysIcon, ResultsIcon, AdvocatesIcon, AssetsIcon },
  computed: {
    ...mapState(useUserStore, ['user', 'true_user']),
    ...mapState(useFeatureStore, ['isFeatureEnabled']),
    is_viewer() {
      return isViewer(this.user)
    },
    navItemClass() {
      return {
        'nav-item': !this.isFeatureEnabled('review_tab'),
        'new-nav-item': this.isFeatureEnabled('review_tab'),
      }
    },
    navbarClass() {
      return {
        'nav-bar': !this.isFeatureEnabled('review_tab'),
        'new-nav-bar': this.isFeatureEnabled('review_tab'),
      }
    },
    items() {
      const advocatesPath = this.isFeatureEnabled('advocates')
        ? '/app/advocates_new'
        : '/app/advocates'
      if (this.is_viewer) {
        return [
          {
            name: 'Assets',
            to: { path: '/app/content_assets' },
            icon: AssetsIcon,
          },
        ]
      }
      if (this.isFeatureEnabled('review_tab')) {
        return [
          {
            name: 'Surveys',
            to: { path: '/app/surveys' },
            icon: SurveysIcon,
          },
          {
            name: 'Responses',
            to: { path: '/app/responses' },
            icon: ResultsIcon,
          },
          {
            name: 'Assets',
            to: { path: '/app/content_assets' },
            icon: AssetsIcon,
          },
          {
            name: 'Advocates',
            to: { path: advocatesPath },
            icon: AdvocatesIcon,
          },
        ]
      } else {
        return [
          {
            name: 'Manage Surveys',
            to: { path: '/app/surveys' },
            icon: SurveysIcon,
          },
          {
            name: 'Explore Responses',
            to: { path: '/app/results/by-survey' },
            icon: ResultsIcon,
          },
          {
            name: 'Assets',
            to: { path: '/app/content_assets' },
            icon: AssetsIcon,
          },
          {
            name: 'Advocates',
            to: { path: advocatesPath },
            icon: AdvocatesIcon,
          },
        ]
      }
    },
  },
}
</script>
<style lang="sass" scoped>
.nav-item
  padding-left: 1rem
  padding-right: 1rem

  svg
    margin-right: 16px

.nav-bar
  padding-top: 1rem !important
  padding-bottom: 1rem !important
  justify-content: space-between !important

.new-nav-item
  padding-left: 1rem
  padding-right: 1rem

  svg
    visibility: hidden
    margin-right: 8px

  .router-link-active, .router-link-exact-active
    svg
      visibility: visible
    color: var(--primary) !important

.new-nav-bar
  padding-top: 1rem !important
  padding-bottom: 1rem !important
  justify-content: space-between !important
</style>
